import { LOGO_URL } from "@/lib/useReveal";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="relative border-t border-black/5 bg-white/60 backdrop-blur-md"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-2.5">
                    <img src={LOGO_URL} alt="" className="logo-blend h-7 w-7 object-contain" />
                    <span className="font-display text-[15px] font-medium">
                        CEO<span className="text-neutral-500">’s</span>{" "}
                        <span className="italic">GPT</span>
                    </span>
                    <span className="text-[12px] text-neutral-400 ml-2">
                        © {new Date().getFullYear()} — Decision OS for Founders
                    </span>
                </div>
                <div className="flex items-center gap-5 text-[12px] text-neutral-500">
                    <a href="#problem" className="hover:text-black transition-colors">Problem</a>
                    <a href="#solution" className="hover:text-black transition-colors">Solution</a>
                    <a href="#agents" className="hover:text-black transition-colors">Agents</a>
                    <a href="#money-meter" className="hover:text-black transition-colors">Money Meter</a>
                    <a href="#scan-ai" className="hover:text-black transition-colors">Scan AI</a>
                </div>
            </div>
        </footer>
    );
}
